import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Backend from "../utils/api.js";
import { clearOAuthAttempt } from "../utils/badgeOAuthTracking";
import { AbsoluteCenter } from "@chakra-ui/react";
import KioskLoadingAnimation from "../Components/KioskLoadingAnimation";

export default function BadgrCallback({ user, onLogin }) {
  const history = useHistory();

  // Restore App user state so ProtectedRoute allows /profile navigation
  useEffect(() => {
    if (user?.UID && onLogin) {
      onLogin({ ...user, status: 200 });
    }
  }, []);

  useEffect(() => {
    // The user made it back from the provider, so this attempt wasn't
    // abandoned -- whatever the outcome below.
    clearOAuthAttempt();

    const params = new URL(window.location.toString()).searchParams;
    const code = params.get("code");
    // state encodes the provider name (set by GET /badges/providers)
    const provider = params.get("state") || "parchment";

    // The provider redirects back with ?error= when the user cancels
    // (access_denied) or authorization fails on its side.
    const oauthError = params.get("error");
    if (oauthError) {
      history.replace("/profile", {
        badgrResult: oauthError === "access_denied" ? "cancelled" : "error",
        badgrError: oauthError === "access_denied" ? undefined : "provider_error",
        badgrProvider: provider,
      });
      return;
    }

    if (!code) {
      history.replace("/profile", { badgrResult: "error", badgrProvider: provider });
      return;
    }

    Backend.badgrOAuth(code, provider)
      .then((res) => {
        if (res && res.linked_count != null) {
          history.replace("/profile", {
            badgrResult: "success",
            providerDisplayName: res.provider_display_name || provider,
          });
        } else {
          console.error("OAuth failed:", res);
          // Keep the backend's error code and message so Profile can tell
          // the user what actually went wrong instead of "please try again".
          history.replace("/profile", {
            badgrResult: "error",
            badgrError: res?.error,
            badgrMessage: res?.message,
            badgrStatus: res?.status,
            badgrProvider: provider,
          });
        }
      })
      .catch((err) => {
        console.error("OAuth request error:", err);
        history.replace("/profile", { badgrResult: "error", badgrProvider: provider });
      });
  }, []);

  return (
    <AbsoluteCenter>
      <KioskLoadingAnimation />
    </AbsoluteCenter>
  );
}
